"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
require("reflect-metadata");
const tsyringe_1 = require("tsyringe");
const types_1 = require("./types");
const PersistentMemory = __importStar(require("./persistent-memory/internal"));
const Chains = __importStar(require("./chains/internal"));
const Ledger = __importStar(require("./ledger/internal"));
const KeyRing = __importStar(require("./keyring/internal"));
const SecretWasm = __importStar(require("./secret-wasm/internal"));
const BackgroundTx = __importStar(require("./tx/internal"));
const Updater = __importStar(require("./updater/internal"));
const Tokens = __importStar(require("./tokens/internal"));
const Interaction = __importStar(require("./interaction/internal"));
const Permission = __importStar(require("./permission/internal"));
__exportStar(require("./persistent-memory"), exports);
__exportStar(require("./chains"), exports);
__exportStar(require("./ledger"), exports);
__exportStar(require("./keyring"), exports);
__exportStar(require("./secret-wasm"), exports);
__exportStar(require("./tx"), exports);
__exportStar(require("./updater"), exports);
__exportStar(require("./tokens"), exports);
__exportStar(require("./interaction"), exports);
__exportStar(require("./permission"), exports);
function init(router, storeCreator, 
// Message requester to the content script.
eventMsgRequester, embedChainInfos, 
// The origins that are able to pass any permission.
privilegedOrigins, rng, commonCrypto, notification, ledgerOptions = {}) {
    tsyringe_1.container.register(types_1.TYPES.ChainsEmbedChainInfos, {
        useValue: embedChainInfos,
    });
    tsyringe_1.container.register(types_1.TYPES.EventMsgRequester, {
        useValue: eventMsgRequester,
    });
    tsyringe_1.container.register(types_1.TYPES.RNG, { useValue: rng });
    tsyringe_1.container.register(types_1.TYPES.CommonCrypto, { useValue: commonCrypto });
    tsyringe_1.container.register(types_1.TYPES.Notification, { useValue: notification });
    tsyringe_1.container.register(types_1.TYPES.ChainsStore, { useValue: storeCreator("chains") });
    tsyringe_1.container.register(types_1.TYPES.InteractionStore, {
        useValue: storeCreator("interaction"),
    });
    tsyringe_1.container.register(types_1.TYPES.KeyRingStore, { useValue: storeCreator("keyring") });
    tsyringe_1.container.register(types_1.TYPES.LedgerStore, { useValue: storeCreator("ledger") });
    tsyringe_1.container.register(types_1.TYPES.LedgerOptions, { useValue: ledgerOptions });
    tsyringe_1.container.register(types_1.TYPES.PermissionStore, {
        useValue: storeCreator("permission"),
    });
    tsyringe_1.container.register(types_1.TYPES.PermissionServicePrivilegedOrigins, {
        useValue: privilegedOrigins,
    });
    tsyringe_1.container.register(types_1.TYPES.PersistentMemoryStore, {
        useValue: storeCreator("persistent-memory"),
    });
    tsyringe_1.container.register(types_1.TYPES.SecretWasmStore, {
        useValue: storeCreator("secretwasm"),
    });
    tsyringe_1.container.register(types_1.TYPES.TokensStore, { useValue: storeCreator("tokens") });
    tsyringe_1.container.register(types_1.TYPES.TxStore, {
        useValue: storeCreator("background-tx"),
    });
    tsyringe_1.container.register(types_1.TYPES.UpdaterStore, { useValue: storeCreator("updator") });
    const interactionService = tsyringe_1.container.resolve(Interaction.InteractionService);
    Interaction.init(router, interactionService);
    const persistentMemory = tsyringe_1.container.resolve(PersistentMemory.PersistentMemoryService);
    PersistentMemory.init(router, persistentMemory);
    const permissionService = tsyringe_1.container.resolve(Permission.PermissionService);
    Permission.init(router, permissionService);
    const chainUpdaterService = tsyringe_1.container.resolve(Updater.ChainUpdaterService);
    Updater.init(router, chainUpdaterService);
    const tokensService = tsyringe_1.container.resolve(Tokens.TokensService);
    Tokens.init(router, tokensService);
    const chainsService = tsyringe_1.container.resolve(Chains.ChainsService);
    Chains.init(router, chainsService);
    const ledgerService = tsyringe_1.container.resolve(Ledger.LedgerService);
    Ledger.init(router, ledgerService);
    const keyRingService = tsyringe_1.container.resolve(KeyRing.KeyRingService);
    KeyRing.init(router, keyRingService);
    const secretWasmService = tsyringe_1.container.resolve(SecretWasm.SecretWasmService);
    SecretWasm.init(router, secretWasmService);
    const backgroundTxService = tsyringe_1.container.resolve(BackgroundTx.BackgroundTxService);
    BackgroundTx.init(router, backgroundTxService);
}
exports.init = init;
//# sourceMappingURL=index.js.map